export const getGridSizes = (
  fullSettings=false,
  workTypesHaveResources=false
) => ({
  name: (fullSettings ? 5 : 6) + (workTypesHaveResources ? 0 : 2),
  wta: fullSettings ? 3 : 6,
  start: 4,
  // teamTogether: workTypesHaveResources ? 2 : 0
})